<template>
  <el-dialog :title="title" :visible.sync="visible" width="800px" @close="handleClose">
    <div class="qrcode-container">
      <div v-if="qrcodeList.length === 0" class="text-center">
        <p>暂无二维码数据</p>
      </div>
      <el-row :gutter="20" v-else>
        <el-col
          v-for="(item, index) in qrcodeList"
          :key="index"
          :span="8"
          class="qrcode-item"
        >
          <div class="qrcode-wrapper">
            <div :id="`qrcode-${index}`" class="qrcode-canvas"></div>
            <p class="qrcode-name">{{ item.qrcodeName || item.name }}</p>
            <p class="qrcode-remark" v-if="item.remark">{{ item.remark }}</p>
          </div>
        </el-col>
      </el-row>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.close') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'ViewMultipleQrcode',
  data() {
    return {
      visible: false,
      title: '二维码',
      qrcodeList: [],
      qrcodes: [] // 存储所有二维码实例
    }
  },
  methods: {
    open(data) {
      // 支持两种数据格式：
      // 1. 数组格式：[{ qrcodeName, qrCodeUrl, remark }, ...]
      // 2. 对象格式：{ title: '标题', qrcodes: [...] }
      console.log(data)
      if (Array.isArray(data)) {
        this.qrcodeList = data
        this.title = '二维码'
      } else if (data && data.qrcodes && Array.isArray(data.qrcodes)) {
        this.qrcodeList = data.qrcodes
        this.title = data.title || '二维码'
      } else if (data && data.qrcodeList && Array.isArray(data.qrcodeList)) {
        this.qrcodeList = data.qrcodeList
        this.title = data.title || '二维码'
      } else {
        this.qrcodeList = []
        this.title = '二维码'
      }

      this.visible = true
      this.$nextTick(() => {
        this.generateQRCodes()
      })
    },
    handleClose() {
      this.clearAllQRCodes()
      this.qrcodeList = []
      this.title = '二维码'
    },
    clearAllQRCodes() {
      // 清除所有二维码实例
      this.qrcodes.forEach((qrcode, index) => {
        if (qrcode) {
          qrcode.clear()
          const element = document.getElementById(`qrcode-${index}`)
          if (element) {
            element.innerHTML = ''
          }
        }
      })
      this.qrcodes = []
    },
    generateQRCodes() {
      this.clearAllQRCodes()

      this.qrcodeList.forEach((item, index) => {
        const qrCodeUrl = item.qrCodeUrl || item.url || item.qrCode || ''
        if (qrCodeUrl) {
          const element = document.getElementById(`qrcode-${index}`)
          if (element) {
            element.innerHTML = ''
            const qrcode = new QRCode(element, {
              text: qrCodeUrl,
              width: 180,
              height: 180,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.L
            })
            this.qrcodes.push(qrcode)
          }
        }
      })
    },
    beforeDestroy() {
      this.clearAllQRCodes()
    }
  }
}
</script>

<style scoped>
.qrcode-container {
  padding: 10px 0;
}

.qrcode-item {
  margin-bottom: 20px;
}

.qrcode-wrapper {
  text-align: center;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #fafafa;
}

.qrcode-canvas {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 15px;
  min-height: 180px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 10px;
}

.qrcode-name {
  margin: 10px 0 5px;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.qrcode-remark {
  margin: 5px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.text-center {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}
</style>

